<template>
  <div>
    <v-data-table
      :items="items"
      :headers="headers"
      :pagination.sync="localPagination"
      :total-items="localPagination.totalItems"
      disable-initial-sort
      hide-actions
      :loading="loading"
      @update:pagination="() => emitPagination()"
    >
      <template #items="{ item }">
        <td class="text-xs-right">{{ item.index }}</td>
        <td class="text-xs-right">{{ item.brokerId || '-' }}</td>
        <td>{{ item.brokerName || '-' }}</td>
        <td>{{ item.email || '-' }}</td>
        <td>{{ item.phone || '-' }}</td>
        <td>
          <template v-if="item.teams.length">
            <v-chip v-for="(team, teamIndex) in item.teams" :key="teamIndex" small>
              {{ team }}
            </v-chip>
          </template>
          <template v-else>-</template>
        </td>
        <td>{{ item.date | DateFormat('DD/MM/YYYY') }}</td>
        <td>
          <DisconnectButton
            v-if="item.isConnected"
            :value="item.brokerId"
            @success="$emit('success:disconnect', $event)"
          />
          <template v-else>-</template>
        </td>
      </template>
    </v-data-table>
    <v-layout v-if="totalPages" class="mt-3">
      <v-spacer />
      <v-pagination
        v-model="localPagination.page"
        :length="totalPages"
        :total-visible="9"
        class="ml-auto"
        @input="() => emitPagination()"
      />
    </v-layout>
  </div>
</template>

<script>
import DisconnectButton from './DisconnectButton.vue'

export default {
  components: { DisconnectButton },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localPagination: {
        page: 1,
        totalItems: 0,
        rowsPerPage: 10,
        ...this.pagination
      },
      headers: [
        { value: 'index', text: this.$t('no.'), sortable: false, align: 'right' },
        {
          value: 'brokerId',
          text: this.$t('asset_wise.broker_id'),
          sortable: false,
          align: 'right'
        },
        { value: 'brokerName', text: this.$t('asset_wise.broker_name'), sortable: false },
        { value: 'email', text: this.$t('email'), sortable: false },
        { value: 'phone', text: this.$t('Phone'), sortable: false },
        { value: 'teams', text: this.$t('asset_wise.team'), sortable: false },
        { value: 'date', text: this.$t('Date'), sortable: false },
        { value: 'isConnected', text: this.$t('asset_wise.disconnect'), sortable: false }
      ],
      hasInit: false
    }
  },
  computed: {
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      return Math.ceil(totalItems / rowsPerPage)
    }
  },
  watch: {
    pagination(value) {
      this.localPagination = { ...this.localPagination, ...value }
    }
  },
  methods: {
    emitPagination() {
      if (!this.hasInit) {
        this.hasInit = true
        return
      }
      this.$emit('update:pagination', this.localPagination)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/Management/Broker/DataTable.vue